import { Injectable } from '@angular/core';
import { Observable ,  ReplaySubject } from 'rxjs';

@Injectable()
export class LoadingIndicatorService {

    showFetchDataLoading$: Observable<boolean>;
    private showFetchDataLoadingSource$ = new ReplaySubject<boolean>(1);

    constructor() {
        this.showFetchDataLoading$ = this.showFetchDataLoadingSource$.asObservable();
    }

    showFetchData(): void {
        this.showFetchDataLoadingSource$.next(true);
    }

    hideFetchData(): void {
        this.showFetchDataLoadingSource$.next(false);
    }
}
